import { shallowMount } from "@vue/test-utils";
import Awards from "@/components/core/Awards";

describe("Awards component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(Awards);
  });

  it("Renders del component Awards", () => {
    expect(wrapper).toBeDefined();
  });

  it("Debe de establecer el valor por defecto", () => {
    expect(wrapper.text()).toContain("");
  });
});
